var _path, _path2, _rect, _path3, _rect2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.3636 81.7383C76.3241 81.7383 70.5195 87.4193 70.5195 94.5824C70.5195 101.622 76.2006 107.426 83.3636 107.426C90.4032 107.426 96.2077 101.745 96.2077 94.5824C96.0842 87.5428 90.4032 81.7383 83.3636 81.7383Z",
    fill: "#A7DEC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.964 20.4819C105.717 20.4819 105.346 20.3584 104.976 20.3584H27.1702L25.9352 12.0838C25.1942 6.64975 20.5012 2.57422 14.9436 2.57422H4.94004C2.22302 2.57422 0 4.79724 0 7.51426C0 10.2313 2.22302 12.4543 4.94004 12.4543H14.9436C15.5611 12.4543 16.0551 12.9483 16.1786 13.5658L23.8357 65.6832C24.8237 72.2287 30.5047 77.1688 37.1738 77.1688H88.5502C94.9722 77.1688 100.53 72.5992 101.888 66.3007L109.916 26.1629C110.41 23.5694 108.681 20.9759 105.964 20.4819Z",
    fill: "#A7DEC9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(51 36)",
    fill: "white",
    fillOpacity: 0.01
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 47V43.002C64 42.7367 63.8946 42.4824 63.7071 42.2948C63.5195 42.1073 63.2652 42.002 63 42.002C62.7347 42.002 62.4804 42.1073 62.2928 42.2948C62.1053 42.4824 62 42.7367 62 43.002V47H58.002C57.7367 47 57.4824 47.1053 57.2948 47.2928C57.1073 47.4804 57.002 47.7347 57.002 48C57.002 48.2652 57.1073 48.5195 57.2948 48.7071C57.4824 48.8946 57.7367 49 58.002 49H62V52.998C62 53.2632 62.1053 53.5175 62.2928 53.7051C62.4804 53.8926 62.7347 53.998 63 53.998C63.2652 53.998 63.5195 53.8926 63.7071 53.7051C63.8946 53.5175 64 53.2632 64 52.998V49H67.998C68.2632 49 68.5175 48.8946 68.7051 48.7071C68.8926 48.5195 68.998 48.2652 68.998 48C68.998 47.7347 68.8926 47.4804 68.7051 47.2928C68.5175 47.1053 68.2632 47 67.998 47H64Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 33,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8698 93.9649C51.6228 87.1723 45.9418 81.7383 39.1492 81.7383C31.9862 82.1088 26.5521 88.0368 26.7991 95.0764C27.0461 101.869 32.6037 107.303 39.3962 107.303H39.6432C46.6828 106.932 52.2403 101.004 51.8698 93.9649Z",
    fill: "#A7DEC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shoppingCart.c586f4219bbb18a7d7ee777ebf823ff0.svg";
export { ForwardRef as ReactComponent };